const $ = jQuery.noConflict();

'use strict';

const LoadPosts = {
	$domContainer: null,
	$domLoadMoreBtn: null,
	$domDropdown: null,
	$domLoader: null,
	$domContainerLoader: null,
	$domNoResults: null,
	postType: null,
	taxonomy: null,
	postsPerPage: null,
	currentPage: 1,
	termId: null,
	selectedTags: [],
	searchQuery: '',

	init: function() {
		if ($('.js-posts').length === 0) {
			return;
		}
		this.initValues();
		this.bindEvents();
	},

	initValues: function(){
		LoadPosts.$domContainer = $('.js-posts-container');
		LoadPosts.$domLoadMoreBtn = $('.js-load-more');
		LoadPosts.$domDropdown = $('.js-filter-dropdown');
		LoadPosts.$domLoader = $('.js-post-loader');
		LoadPosts.$domContainerLoader = $('.js-container-loader');
		LoadPosts.$domNoResults = $('.js-blog-no-results');
		LoadPosts.postType = window.fwsPostType;
		LoadPosts.taxonomy = window.fwsTaxonomy;
		LoadPosts.postsPerPage = window.fwsPerPage;
	},

	bindEvents: function() {
		// Load More
		LoadPosts.$domLoadMoreBtn.on('click', function() {
			LoadPosts.currentPage++;
			LoadPosts.loadPosts(true);
		});
		// Filter dropdown
		LoadPosts.$domDropdown.on('change', function() {
			const termId = $(this).val();
			LoadPosts.termId = termId ? termId : 0;
			LoadPosts.currentPage = 1;
			LoadPosts.$domLoadMoreBtn.show();
			LoadPosts.showContainerLoader(true);
			LoadPosts.loadPosts(false);
		});
		$(document).on('click', '.js-topic-tag', function(e) {
			if ($(this).parent().hasClass('is-disabled')) {
				e.preventDefault();
				return;
			}
			LoadPosts.tagsEvent(this);
			LoadPosts.clearUrl();
		});

		$(document).ready(function() {
			LoadPosts.triggerTagsFromUrl();
		});
	},

	tagsEvent: function(el) {
		const $item = $(el).parent();
		const tagId = parseInt($(el).data('id'));
		$('.tags-list__item').removeClass('is-active');

		if (tagId === 0) {
			LoadPosts.selectedTags = [];
			$item.addClass('is-active');
		} else {
			LoadPosts.selectedTags = [tagId];
			$item.addClass('is-active');
		}
		LoadPosts.currentPage = 1;
		LoadPosts.loadPosts(false);
	},

	triggerTagsFromUrl: function() {
		const topicId = LoadPosts.getParamFromUrl('topic');
		if (topicId) {
			$('.js-topic-tag[data-id="' + topicId + '"]').trigger('click');
		}
	},

	clearUrl: function() {
		const url = new URL(window.location);
		url.searchParams.delete('search');
		url.searchParams.delete('topic');
		window.history.replaceState({}, '', url);
	},

	prepareData: function() {
		return {
			action: 'load-posts',
			postType: LoadPosts.postType,
			taxonomy: LoadPosts.taxonomy,
			termId: LoadPosts.termId,
			tags: LoadPosts.selectedTags,
			search: LoadPosts.searchQuery,
			page: LoadPosts.currentPage,
			limit: LoadPosts.postsPerPage
		};
	},

	loadPosts: function(append = false) {
		$.ajax({
			method: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: this.prepareData(),
			beforeSend: function() {
				LoadPosts.showLoader(true);
				LoadPosts.showContainerLoader(true);
			},
			success: function(response) {
				if (response.success) {
					LoadPosts.renderPosts(response.data.posts, append);
					LoadPosts.updatePagination(response.data);
					if (!append) {
						$('html, body').animate({
							scrollTop: LoadPosts.$domContainer.offset().top - 100
						}, 400);
					}
				}
			},
			error: function(err) {
				LoadPosts.showLoader(false);
				LoadPosts.showContainerLoader(false);
				console.error('AJAX error:', err);
			},
			complete: function() {
				LoadPosts.showLoader(false);
				LoadPosts.showContainerLoader(false);
			},
		});
	},

	renderPosts: function(posts, append = false) {
		LoadPosts.showNoResults(posts);
		if (append) {
			LoadPosts.$domContainer.append(posts);
		} else {
			LoadPosts.$domContainer.html(posts);
		}
	},

	showNoResults: (posts)=>{
		posts ? LoadPosts.$domNoResults.hide() : LoadPosts.$domNoResults.show();
	},

	updatePagination: function(data) {
		LoadPosts.currentPage = data.currentPage;
		!data.hasMore ? LoadPosts.$domLoadMoreBtn.hide() : LoadPosts.$domLoadMoreBtn.show();
	},

	getParamFromUrl: (param) => {
		const params = new URLSearchParams(window.location.search);
		return params.get(param);
	},

	showLoader: function(show) {
		LoadPosts.$domLoader.toggleClass('is-active', show);
	},

	showContainerLoader: function(show) {
		LoadPosts.$domContainerLoader.toggleClass('is-active', show);
	},
};

export default LoadPosts;
